import React from "react";
import locale from "localization";
import styles from "./station-view.module.scss";
import { FormMode, Path, Permission } from "enums";
import { BackLink, Title, Text, Button } from "components/commons";
import StationDetailsModule from "../station-details/station-details.module";
import { useHistory } from "react-router-dom";
import { usePermission } from "hooks";
import moment from "moment";
import { EditOutlined } from "@material-ui/icons";

const StationViewModule = (props) => {
  const params = props.location.state ? props.location.state.params : "";
  const history = useHistory();
  const { can } = usePermission();
  const canEditStation = can(Permission.StationEdit);

  const lastEditedAt = (() => {
    const stationUpdated = params.updatedAt;
    const productUpdated = params.stationProduct?.updatedAt;
    if (stationUpdated && productUpdated) {
      return stationUpdated > productUpdated ? stationUpdated : productUpdated;
    }
    return stationUpdated || productUpdated || null;
  })();

  return (
    <div>
      <BackLink text={locale.stationAccountList} path={Path.StationList} />
      <div className={styles.intro}>
        <div className={styles.header}>
          <Title className={styles.title}>{locale.seaoilStationDetails}</Title>
          <div className={styles.headerRight}>
            {lastEditedAt && lastEditedAt !== params.createdAt && (
              <Text className={styles.lastEdited}>
                Last edited on {moment(lastEditedAt).format("DD MMM YYYY h:mma")}
              </Text>
            )}
            {canEditStation && (
              <Button
                outline
                startIcon={<EditOutlined />}
                onClick={() => history.push(Path.EditStation, { params })}
                className={styles.editButton}
              >
                {locale.edit}
              </Button>
            )}
          </div>
        </div>
        <StationDetailsModule pageMode={FormMode.View} stationData={params} />
      </div>
    </div>
  );
};

export default StationViewModule;
